import script from "./programdetails.vue?vue&type=script&setup=true&lang=js"
export * from "./programdetails.vue?vue&type=script&setup=true&lang=js"

import "./programdetails.vue?vue&type=style&index=0&id=376c05c4&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376c05c4"]])

export default __exports__